/* ==========================================================================
   InputRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const configuration = require('./client/js/config');

const getStyles = data => {
    const { value, isAlternative, hidden, active, disabled } = data;

    return [
        isAlternative ? configuration().css.alternative : '',
        disabled ? configuration().css.disabled : '',
        hidden ? configuration().css.hidden : '',
        active || (value !== undefined && value !== null) ? configuration().css.active : ''
    ];
};
/**
 * InputRxjs template
 * @param {object} data Object containing the data model for this component.
 * @returns {string} Html
 */
module.exports = function Template(data = {}, context = {}) {
    /* Data */
    const {
        config = {},
        label,
        icon,
        placeholder,
        type = 'text',
        name,
        title,
        content,
        value,
        min = false,
        max = false,
        maxlength = false,
        disabled = false,
        hidden = false,
        active = false,
        hasLoader = true,
        step = false
    } = data;
    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Template */
    return html(`
        <div class='${['input-rxjs', ...getStyles({ ...config, value, hidden, active, disabled }), ...styles]
            .join(' ')
            .trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                ...config,
                active,
                disabled,
                hidden,
                hasLoader
            })}'>

            ${label ? `<label>${label}</label>` : ''}
            ${icon ? ViewHelpers(context).icon(icon) : ''}
            <input type='${type}'
                ${title ? `title='${title}'` : ''}
                ${name ? `name='${name}'` : ''}
                ${content ? `content='${content}'` : ''}
                ${config.isAlternative ? `placeholder='${placeholder}'` : ''}
                ${min ? `min='${min}'` : ''}
                ${max ? `max='${max}'` : ''}
                ${value ? `value='${value}'` : ''}
                ${step ? `step='${step}'` : ''}
                ${maxlength ? `maxlength='${maxlength}'` : ''}>
        </div>
    `);
};
